import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";

import type { WorkItemPriority } from "../../types";

const priorityVariant: Record<string, string> = {
  urgent: "border-red-300 dark:border-red-700",
  high: "border-orange-300 dark:border-orange-700",
  normal: "border-blue-300 dark:border-blue-700",
  low: "border-muted",
};

export const PriorityBadge = ({
  priority,
}: {
  priority?: WorkItemPriority | null;
}) => {
  const translate = useTranslate();
  if (!priority) return null;
  return (
    <Badge variant="outline" className={priorityVariant[priority] ?? ""}>
      {translate(`resources.work_items.priority.${priority}`, {
        _: priority,
      })}
    </Badge>
  );
};
